<template>
    <div class="view-error-general view" :style="{'min-height':height+'px'}">
        <div class="error" :style="{'margin-top':height-343>0?((height-343)/2 + 'px'): '0px'}">
            <img :src="require('../../assets/img/error-general.png')" alt="error">
            <div class="error-text">
                <h1>系统维护中</h1>
                <!-- <p class="title">
                    维护时间为2023.04.29-2023.05.03
                </p> -->
                <p class="title">如有需要请联系客服，电话：400-698-9988</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            height: document.documentElement.clientHeight - 247
        };
    },
    mounted () {
        const _this = this;
        window.onresize = () => {
            _this.height = document.documentElement.clientHeight - 247;
        };
    },
    methods: {
        loadToHome () {
            if (this.$store.state.login.status) {
                this.$router.replace("/home");
            } else {
                this.$router.replace("/");
            }
        },
        loadRefresh () {
            this.$router.go(-1);
        }
    }
};
</script>
<style lang="scss">
    .view-error-general{
        text-align: center;
        .error {
            // width: 790px;
            display: inline-block;
            vertical-align: middle;
        }
        .error img {
            vertical-align: middle;
        }

        .error .error-text {
            vertical-align: middle;
            margin-left: 55px;
            // width: 450px;
            text-align: left;
            display: inline-block;
        }

        .error .error-text h1 {
            color: #008cd4;
            font-size: 100px;
        }
        .error .error-text .title{
            color: #008cd4;
            font-size:36px;
            margin:20px 0;
            line-height: 40px;
        }
        .error .error-text p {
            color: #999999;
            font-size: 18px;
            line-height: 36px;
        }

        .error .error-text button {
            margin-top: 36px;
        }
        .error .error-text .last{
            margin-left: 20px;
        }
    }
</style>
